module.exports = __webpack_public_path__ + "img/01adfa6.jpg";